function online() {
    window.open('https://work.weixin.qq.com/kfid/kfcd41bee99be7f9223', '_blank');
}

export {
    online
}